import React, {useEffect} from "react";
import style from "./RollingDice.module.css"
import {trySetTimeout} from "../hooks/trySetTiemout";
export default function RollingDiceComponent(props) {
    let canRoll = true

    const getRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    }

    useEffect(() => {
        const [angleX, angleY, _] = determineAngles(props.dice_num)
        document.querySelector('#dice').style.transform = "rotateX(" + angleX + "deg) rotateY(" + angleY + "deg)"
        document.querySelector('#dice').style.transitionDuration = 0 + 'ms'
    }, [props.dice_num])

    function roll() {
        canRoll = false

        const new_dice_val = 1 + getRandomInt(6)

        const delay = animateDice(new_dice_val)

        trySetTimeout(() => canRoll = true, delay)
        trySetTimeout(() => props.sendDiceValue(new_dice_val), delay * 0.8)
    }

    function determineAngles(diceVal) {
        let xTurn = 0
        let yTurn = 0
        switch (diceVal) {
            case 1:
                xTurn = 4
                yTurn = 8
                break
            case 2:
                xTurn = 6
                yTurn = 5
                break
            case 3:
                xTurn = 7
                yTurn = 4
                break
            case 4:
                xTurn = 5
                yTurn = 4
                break
            case 5:
                xTurn = 4
                yTurn = 5
                break
            case 6:
                xTurn = 6
                yTurn = 4
                break
        }

        const angleX = 90 * xTurn
        const angleY = 90 * yTurn
        const delay = Math.max(xTurn, yTurn)*250
        return [angleX, angleY, delay]
    }

    function animateDice(diceVal) {
        const [angleX, angleY, delay] = determineAngles(diceVal)

        document.querySelector('#dice').style.transform = "rotateX(" + (180 + getRandomInt(90)) + "deg) rotateY(" + (180 + getRandomInt(90)) + "deg)"
        document.querySelector('#dice').style.transitionDuration = delay/2 + 'ms'
        document.querySelector('#dice').style.transitionTimingFunction = "linear"

        trySetTimeout(() => {
            document.querySelector('#dice').style.transform = "rotateX(" + (180 + getRandomInt(90)) + "deg) rotateY(" + (180 + getRandomInt(90)) + "deg)"
            document.querySelector('#dice').style.transitionDuration = delay + 'ms'
            document.querySelector('#dice').style.transitionTimingFunction = "linear"
            trySetTimeout(() => {
                document.querySelector('#dice').style.transform = "rotateX(" + angleX + "deg) rotateY(" + angleY + "deg)"
                document.querySelector('#dice').style.transitionDuration = delay + 'ms'
                document.querySelector('#dice').style.transitionTimingFunction = "ease-out"
            }, delay/5)
        }, delay/5)

        return delay
    }



    return(
        <div>
            <div className={style.diceContainer} id={'dice-container'}>
                <div className={style.dice} id={'dice'} onClick={() => canRoll && roll()}>
                    <div className={style.face1} data-id='1' id={"1"}>
                        <div className={`${style.point} ${style.pointMiddle} ${style.pointCenter}`}></div>
                    </div>
                    <div className={style.face2} data-id='2' id={"2"}>
                        <div className={`${style.point} ${style.pointTop} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointLeft}`}>
                        </div>
                    </div>
                    <div className={style.face6} data-id='6'>
                        <div className={`${style.point} ${style.pointTop} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointTop} ${style.pointLeft}`}>
                        </div>
                        <div className={`${style.point} ${style.pointMiddle} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointMiddle} ${style.pointLeft}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointLeft}`}>
                        </div>
                    </div>
                    <div className={style.face5} data-id='5'>
                        <div className={`${style.point} ${style.pointTop} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointTop} ${style.pointLeft}`}>
                        </div>
                        <div className={`${style.point} ${style.pointMiddle} ${style.pointCenter}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointLeft}`}>
                        </div>
                    </div>
                    <div className={style.face3} data-id='3'>
                        <div className={`${style.point} ${style.pointTop} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointMiddle} ${style.pointCenter}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointLeft}`}>
                        </div>
                    </div>
                    <div className={style.face4} data-id='4'>
                        <div className={`${style.point} ${style.pointTop} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointTop} ${style.pointLeft}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointRight}`}>
                        </div>
                        <div className={`${style.point} ${style.pointBottom} ${style.pointLeft}`}>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}